import tasksData from '@/mockData/tasks.json'
import ProjectsService from '@/services/api/projects.services'
import projectsServices from "@/services/api/projects.services";


const state = {
    tasks: tasksData,
    selectedUserTasks: [],
    currentUserTasks: [],
    myTasks: [],
    projectTasks: [],
    taskStatuses: [],
    preloader: false,
    projectSlug: {},
    taskSlug: {},
    clickedTaskProp: {}
}

const mutations = {
    SET_PRELOADER(state, payload) {
        state.preloader = payload
    },

    SET_CLICKED_TASK(state, payload) {
        state.clickedTaskProp = payload
    },
    ADD_TASK(state, payload) {
        state.tasks.push(payload)
    },
    CHANGE_TASK_STATUS(state, payload) {
        let idx = state.tasks.findIndex(item => item.id == payload.id)
        state.tasks[idx].status = payload.status
    },
    SET_SELECTED_USER_TASKS(state, payload) {
        state.selectedUserTasks = payload
    },
    SET_CURRENT_PROJECT_TASKS(state, payload) {
        state.projectTasks = payload;
    },
    SET_CURRENT_PROJECT_SLUG(state, payload) {
        state.projectSlug = payload;
    },
    SET_CURRENT_TASK_SLUG(state, payload) {
        state.taskSlug = payload;
    },
    SET_MY_TASKS(state, payload) {
        state.myTasks = payload
    },
    SET_TASKS_STATUSES(state, payload) {
        state.taskStatuses = payload
    },
    SET_CURRENT_USER_TASKS(state, payload) {
        state.currentUserTasks = payload
    },
}

const actions = {
    createTask(context, payload) {
        return new Promise((resolve, reject) => {
            projectsServices.post('createTask', {}, payload, {
                Accept: "*/*",
                "Content-Type": "multipart/form-data",
            })
                .then((response) => {
                    return resolve(response);
                }).catch((error) => reject(error))
        })
        // commit('ADD_TASK', form)
    },

    getProjectTasks({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('projectTasks', id).then((response) => {
                commit('SET_CURRENT_PROJECT_TASKS', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getProjectSlug({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('projectSlug', id).then((response) => {
                commit('SET_CURRENT_PROJECT_SLUG', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getTaskSlug({ commit }, params) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('taskSlug', params)
                .then((response) => {
                    commit('SET_CURRENT_TASK_SLUG', response.data.data)
                    return resolve(response)
                })
                .catch(({ errors }) => reject(errors))
        })
    },

    getUserTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('userTasks', payload)
                .then((response) => {
                    commit('SET_SELECTED_USER_TASKS', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getMyCurrentTasks({commit}) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('personalTasks')
                .then((response) => {
                    commit('SET_MY_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getTaskStatuses({ commit }) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('taskStatuses')
                .then((response) => {
                    commit('SET_TASKS_STATUSES', response.data.data);
                    return resolve(response);
                })
            .catch((error) => reject(error))
        })
    },
    getCurrentUserTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('userTasks', payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getTodos({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('todos', payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getComments({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('comments', payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  getCurrentProjects({ commit }) {
    return new Promise((resolve, reject) => {
      ProjectsService.get('projects')
        .then((response) => {
          commit('SET_CURRENT_USER_TASKS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
    deleteTask(context, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.delete('deleteTask', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    changeStatus(context, {id, payload}) {
        return new Promise((resolve, reject) => {
            projectsServices.put('changeTaskStatus', id, payload)
                .then((response) => {
                    return resolve(response);
                }).catch((error) => reject(error))
        })
    },

    changeOrder(context, {id, payload}) {
        return new Promise((resolve, reject) => {
            projectsServices.put('changeOrder', id, payload)
                .then((response) => {
                    return resolve(response);
                }).catch((error) => reject(error))
        })
    },

    editTask(context, {id, payload}) {
        return new Promise((resolve, reject) => {
            ProjectsService.put('editTask', id, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    editComment(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.editNewTaskComment(payload.taskId, payload.commentId,  payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    editTodo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.editTodo(payload.taskId, payload.commentId,  payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deleteComment(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.deleteNewTaskComment(payload.taskId, payload.commentId)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },


    deleteTodo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.deleteTodo(payload.taskId, payload.commentId)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    addNewComment(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.addNewComment(payload.taskId, payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    addTodo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.addTodo(payload.taskId, payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    addNewTask({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.createNewTask(payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getData: state => user => state.tasks.filter(item => item.workers.some(worker => worker === user)),
    getUserTasks: state => state.selectedUserTasks,
    getCurrentProjectTasks: state => state.projectTasks,
    getFilteredCurrentTasks: state => filters => Object.entries(filters).length == 0 ? state.projectTasks : state.projectTasks.filter(item => item.area.includes(filters.area) && item.type == filters.type && item.priority.includes(filters.priority) && item.product_type.includes(filters.productType)),
    getCurrentUserTasks: state => state.currentUserTasks,
    getMyTasks: state => state.myTasks,
    getTaskStatuses: state => state.taskStatuses,
    preloader: state => state.preloader,
    getProjectSlug: state => state.projectSlug,
    getClickedTaskProp: state => state.clickedTaskProp
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
